import React from 'react';
import { AppCheckboxFormLabel } from '@/components/atoms';

interface TreatmentReportPrintOptionsProps {
  allChecked: boolean;
  disabled: boolean;
  isIndeterminate: boolean;
  onToggleAll: () => void;
}

export const TreatmentReportPrintOptions: React.FC<TreatmentReportPrintOptionsProps> = ({
  allChecked,
  disabled,
  isIndeterminate,
  onToggleAll,
}) => (
  <div className="flex items-center gap-2 mb-4">
    <AppCheckboxFormLabel
      label="チェックした項目は施術報告書に印字する"
      checked={allChecked}
      indeterminate={isIndeterminate}
      onChange={onToggleAll}
      disabled={disabled}
      data-skip-enter-nav
    />
  </div>
);

